import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import navContext from "../../../Context/navContext";
import { MdDownload, MdOutlineRemoveRedEye } from "react-icons/md";
import { useParams } from "react-router-dom";
import Loader from "../../../Loader/Loader";
import Modal from "../../../Modal/Modal";
import FormShareDetails from "./FormShareDetails/FormShareDetails";
import {
  downloadfile,
  findAllByShare,
} from "../../../../services/ShareDetails__Servive";
import { findOne } from "../../../../services/Share__Service";
import { securityGestionnaire } from "../../../../services/Auth__Service";

const ListShareDetails = () => {
  /* Handle Modal */
  const [viewShareDetailsId, setViewShareDetailsId] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  /* End Handle Modal */

  const paramsRoutes = useParams();

  const [id, setId] = useState(paramsRoutes.id);

  const [shareDetails, setShareDetails] = useState(null);
  const [share, setShare] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);

  const downloadHandle = React.useCallback(
    (filename, nameDownload) => () => {
      downloadfile(filename, nameDownload);
    },
    []
  );

  const columns = useMemo(
    () => [
      {
        field: "Message",
        headerName: "Message",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => {
          return params.row.message;
        },
      },
      {
        field: "Date",
        headerName: "Date",
        minWidth: 110,
        type: "date",
        valueGetter: (params) => {
          return new Date(params.row.dateCreate).toLocaleDateString("fr-FR");
        },
      },

      {
        field: "Heure",
        headerName: "Heure",
        minWidth: 110,
        type: "time",
        valueGetter: (params) => {
          return params.row.timeCreate;
        },
      },

      {
        field: "Par",
        headerName: "Par",
        minWidth: 110,
        valueGetter: (params) => {
          return params.row.createdBy.isAdmin
            ? "Administrateur"
            : params.row.createdBy.fullname;
        },
      },

      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdDownload />}
            label="Télécharger"
            onClick={downloadHandle(
              params.row.filename,
              params.row.nameDownload
            )}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewShareDetailsId(params.id)}
            showInMenu
          />,
        ],
      },
    ],
    [downloadHandle]
  );

  useEffect(() => {
    nav({
      links: [
        {
          href: "/client/share/",
          linkname: "Docs. Paie",
        },
        {
          href: "/client/share/" + paramsRoutes.shareId + "/details/",
          linkname: share ? share.name : "",
        },
      ],

      children:
        !share || share.statut ? (
          <button className="btn" onClick={() => setShowAdd(true)}>
            Nouvel élément
          </button>
        ) : (
          <p
            style={{
              color: "red",
              fontWeight: "700",
            }}
          >
            Fermé
          </p>
        ),
    });

    if (share) {
      securityGestionnaire(share.client.id);
    }
  }, [shareDetails, share]);

  useEffect(() => {
    if (!showAdd) {
      setIsLoading(true);
      fetchAllShareDetailsByShare(paramsRoutes.shareId);
    }
  }, [showAdd]);

  useEffect(() => {
    fetchOneShare(paramsRoutes.shareId);
  }, []);

  const fetchAllShareDetailsByShare = async (id) => {
    findAllByShare(id)
      .then((response) => {
        setShareDetails(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const fetchOneShare = async (shareId) => {
    findOne(shareId)
      .then((response) => {
        setShare(response.data);
      })
      .catch((error) => {});
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="shareDetails__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={shareDetails}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>

      {isLoading && <Loader loadingMsg="Chargement" />}

      {viewShareDetailsId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Élément de partage</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewShareDetailsId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormShareDetails
                  shareDetailsId={viewShareDetailsId}
                  view={true}
                />
              </div>
              <div className="modal__footer">
                <button
                  className="btn"
                  onClick={() => setViewShareDetailsId(0)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {showAdd && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Élément de partage</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setShowAdd(false)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormShareDetails setShowAdd={setShowAdd} />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListShareDetails;
